module.exports = __webpack_public_path__ + "static/media/ring3.5f3f5f0a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/branding/default/audio/ring3.mp3
// module id = 613
// module chunks = 0